/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-09T18:45:59.612
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveReportRentContractRequestRelet,
	getReportRentContractRequestReletCreateInit,
	getReportRentContractRequestReletEditInit,
	getReportRentContractRequestReletView,
	deleteReportRentContractRequestRelet
} from '@api/report/ReportRentContractRequestRelet';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getReportRentContractRequestReletCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getReportRentContractRequestReletCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportRentContractRequestReletEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportRentContractRequestReletEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveReportRentContractRequestRelet({}, ReportRentContractRequestRelet) {
			return new Promise((resolve, reject) => {
				saveReportRentContractRequestRelet(ReportRentContractRequestRelet)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getReportRentContractRequestReletView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportRentContractRequestReletView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteReportRentContractRequestRelet({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportRentContractRequestRelet({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
